/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-export': {
    width: 5,
    height: 7,
    viewBox: '0 0 5 7',
    data: '<defs><path pid="0" d="M4.75 6.65H0v-.81l.33-.03c.193-.02.29-.113.29-.28V.88L.05.85V0h4.58v1.66l-1.02.07v-.4c0-.113-.017-.193-.05-.24-.033-.047-.113-.07-.24-.07H1.84v1.71h2.31v1.02H1.84v1.87h1.61c.12 0 .197-.025.23-.075.033-.05.05-.132.05-.245v-.5l1.02.07v1.78z" id="svgicon-icon-status-export-a"/></defs><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon-icon-status-export-a"/>'
  }
})
